import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberContributePage from "@/pages/member/MemberContributePage";

export const Route = createFileRoute("/member/contribute")({
  head: () => pageHead("Member · Contribute", "AKIVA member · contribute portal.", "/member/contribute", true),
  component: MemberContributePage,
});
